// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1MTBf","text":"SelectPayment_text__jf1gn","title":"SelectPayment_title__34peL","btn":"SelectPayment_btn__3Ma7H"};